import { createFileRoute } from "@tanstack/react-router";
import { ActivityPage } from "../../../components/cases/activity-page";

/** A playbook's Activity: what needs you first, then its cases. Keyed by playbook. */
export const Route = createFileRoute("/_authenticated/_workspace/activity/$playbookId")({
  component: function ActivityRoute() {
    const { playbookId } = Route.useParams();
    return <ActivityPage key={playbookId} playbookId={playbookId} />;
  },
});
